import React from 'react';
import PropTypes from 'prop-types';
import {ThemeProvider} from '@mui/material/styles';

// AD-2797 (Maria, 29 October 2026): Esc does nothing in the Add and Edit Contact boxes, so nothing typed is lost.
// They close with the cross or Cancel.
export const closeUnlessEscape = onClose => (event, reason) => {
    if (reason === 'escapeKeyDown') return;
    onClose?.(event, reason);
};

// AD-2797: every address box shows its label on the border, as Country does, rather than inside the empty box where
// it looks like placeholder text. Only the contact boxes use this; other address boxes are unchanged.
export const labelsOnBorderTheme = outer => ({
    ...outer,
    components: {
        ...outer.components,
        MuiInputLabel: {...outer.components?.MuiInputLabel, defaultProps: {...outer.components?.MuiInputLabel?.defaultProps, shrink: true}},
        MuiOutlinedInput: {...outer.components?.MuiOutlinedInput, defaultProps: {...outer.components?.MuiOutlinedInput?.defaultProps, notched: true}}
    }
});

export const LabelsOnBorder = ({children}) => <ThemeProvider theme={labelsOnBorderTheme}>{children}</ThemeProvider>;

LabelsOnBorder.propTypes = {
    children: PropTypes.node
};

// AD-2797: a list opens under its field, not over it.
export const MENU_UNDER_FIELD = {
    anchorOrigin: {vertical: 'bottom', horizontal: 'left'},
    transformOrigin: {vertical: 'top', horizontal: 'left'},
    PaperProps: {sx: {maxHeight: 320}}
};
